import { FunctionComponent } from "react";
import { StyledCustomDropdown } from "./attribute-group-multiselect.styles";
import { filterAddAttribute } from "modules/filter/actions";
import { DropdownItem } from "components/dropdown";

interface AttributeGroupMultiselectProps {
  group: any;
}

const AttributeGroupMultiselect: FunctionComponent<
  AttributeGroupMultiselectProps
> = ({ group }) => {
  return (
    <div>
      <StyledCustomDropdown
        label={group.name}
        items={group.attributes.map((attribute: any) => {
          const item: DropdownItem = {
            text: attribute.name,
            onClick: () => {
              filterAddAttribute(attribute.uuid);
            },
          };
          return item;
        })}
      />
    </div>
  );
};

export default AttributeGroupMultiselect;
